import { css } from 'linaria';
const cache = {};
export default function createVideo(_ref) {
  let {
    src,
    autoplay,
    parent = document.body
  } = _ref;
  if (cache[src]) return cache[src];
  let video = document.createElement('video');
  video.muted = true;
  video.playsInline = true;
  video.loop = true;
  video.crossOrigin = 'anonymous';
  video.src = src;
  video.classList.add("c185gxjh");
  parent.appendChild(video);
  video.load();
  if (autoplay) video.play();
  cache[src] = video;
  return video;
}

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/lib/create-video.linaria.css");